/**
 * @generated SignedSource<<43dbc1ed6f58cec4b3466d01896da7d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type ProjectV2SingleSelectFieldOptionColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ProjectItemSection$data = {
  readonly fieldValueByName: {
    readonly color?: ProjectV2SingleSelectFieldOptionColor;
    readonly id?: string;
    readonly name?: string | null | undefined;
    readonly nameHTML?: string | null | undefined;
    readonly optionId?: string | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly isArchived: boolean;
  readonly project: {
    readonly field: {
      readonly databaseId?: number | null | undefined;
      readonly id?: string;
      readonly name?: string;
      readonly options?: ReadonlyArray<{
        readonly color: ProjectV2SingleSelectFieldOptionColor;
        readonly description: string;
        readonly descriptionHTML: string;
        readonly id: string;
        readonly name: string;
        readonly nameHTML: string;
        readonly optionId: string;
      }>;
    } | null | undefined;
    readonly id: string;
    readonly template: boolean;
    readonly title: string;
    readonly url: string;
    readonly viewerCanUpdate: boolean;
  };
  readonly " $fragmentType": "ProjectItemSection";
};
export type ProjectItemSection$key = {
  readonly " $data"?: ProjectItemSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectItemSection">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "Status"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "optionId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameHTML",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectItemSection",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArchived",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectV2",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "template",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanUpdate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": null,
          "kind": "LinkedField",
          "name": "field",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "databaseId",
                  "storageKey": null
                },
                (v0/*: any*/),
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectV2SingleSelectFieldOption",
                  "kind": "LinkedField",
                  "name": "options",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    (v3/*: any*/),
                    (v2/*: any*/),
                    (v4/*: any*/),
                    (v5/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "descriptionHTML",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "ProjectV2SingleSelectField",
              "abstractKey": null
            }
          ],
          "storageKey": "field(name:\"Status\")"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v1/*: any*/),
      "concreteType": null,
      "kind": "LinkedField",
      "name": "fieldValueByName",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            (v3/*: any*/),
            (v2/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/)
          ],
          "type": "ProjectV2ItemFieldSingleSelectValue",
          "abstractKey": null
        }
      ],
      "storageKey": "fieldValueByName(name:\"Status\")"
    }
  ],
  "type": "ProjectV2Item",
  "abstractKey": null
};
})();

(node as any).hash = "12c6cb93729848a8c2b01eb442015ecf";

export default node;
